module.exports = __webpack_public_path__ + "static/media/Videos@3x.0d33ab74.png";